<template>
  <Layout>
    <Loader :loading="loadingExport" no-axios>
      <div class="">
        <div class="title">{{ lodash.upperCase(title) }}</div>
        <div v-if="!lodash.isEmpty(filterColumns)">
          <model-filter
            v-model="filter"
            :columns="filterColumns"
            :modelVariable="modelVariable"
            :filterHandler="filterHandler"
          />
        </div>
      </div>
      <!-- <div class="title">{{ lodash.upperCase($t("List")) }} {{ lodash.upperCase(title) }}</div> -->
      <div class="row">
        <model-index
          ref="table"
          class="col-12"
          :loading="loading"
          v-bind="$props"
          :columns="columns"
          :busy.sync="busy"
          :models-paginated="modelsPaginated"
          :page.sync="page"
          :per-page.sync="perPage"
          :from="from"
          :total="totalFiltered"
          :search.sync="search"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :filter-params.sync="filterParams"
          @create-click="handleCreate"
          @export-click="handleExport"
          @show-click="handleShow"
          @edit-click="handleEdit"
          @delete-click="handleDelete"
        >
        </model-index>
      </div>
    </Loader>
  </Layout>
</template>
<script>
import ModelIndex from "../models/index-v3"

export default {
  extends: ModelIndex,
  page: {
    title: "Approval Templates",
  },
  props: {
    cardTitle: {default() { return this.lodash.upperCase(`${this.$t("List")} ${this.$t('approval_templates.plural')}`) } },
    resourceRoute: {default: 'approval_templates'},
    modelVariable: {default: 'approval_template'},
    denyCreate: { type: Boolean, default() { return !this.$auth.hasPermissionTo('approval_rules.create') } }
  },
  data() {
    return {
      title: this.lodash.upperFirst(this.$t('approval_templates.plural')),
      items: [
        {
          text: this.lodash.upperFirst(this.$t('approval_templates.plural')),
          href: "/approval_templates",
          active: true,
        },
      ],
      togglingId: null,
      // filterColumns: {
      //   name: { type: String, label: this.lodash.upperFirst(this.$t('approval_templates.name')) },
      //   code: { type: String, label: this.lodash.upperFirst(this.$t('approval_templates.code')) },
      //   type: { type: String, label: this.lodash.upperFirst(this.$t('approval_templates.type')) }
      // }
    }
  },
  computed: {
    columns() {
      const vm = this
      return {
        ['approval_template']: [
          { key: 'index', label: 'No', sortable: false, style: { width: '1%' } },
          {
            key: 'name',
            label: this.lodash.upperFirst(this.$t('approval_templates.name')),
            thStyle: { minWidth: '125px' },
            sortable: true
          },
          {
            key: 'approvable_type',
            label: this.lodash.upperFirst(this.$t('approval_templates.approvable_type')),
            thStyle: { minWidth: '175px' },
            formatter: (value) => this.getApprovableTypeLabel(value)
          },
          {
            key: 'approval_template_steps_count',
            label: this.lodash.upperFirst(this.$t('approval_templates.approval_template_steps_count')),
            thStyle: { minWidth: '200px' },
          },
          {
            key: 'is_active',
            label: this.lodash.upperFirst(this.$t('approval_templates.status')),
            thStyle: { minWidth: '125px' },
            component: {
              props: ['item'],
              computed: {
                isLoading() { return vm.togglingId === this.item.id }
              },
              methods: {
                toggle(newValue) { vm.toggleIsActive(this.item, newValue) }
              },
              template: `
                <div>
                  <b-form-checkbox :checked="!!item.is_active" name="check-button" switch :disabled="isLoading || !!item.is_active" @change="toggle">
                    <span v-if="item.is_active">{{ $t('approval_templates.active') }}</span>
                    <span v-else>{{ $t('approval_templates.inactive') }}</span>
                  </b-form-checkbox>
                </div>
              `
            }
          },
          { key: 'action', label: this.$t('Action'), class: 'text-center', style: { width: '1%' } }
        ],
      };
    },
  },
  methods: {
    /**
     * TODO: ganti jadi model Rencana Pembelian / Rencana Penjualan
     */
    getApprovableTypeLabel(type) {
      const typeMap = {
        'App\\Models\\SaleOrder': this.$t('menus.sales'),
        'App\\Models\\PurchaseOrder': this.$t('menus.purchase')
      };
      return typeMap[type] || type;
    },
    toggleIsActive(item, newValue) {
      this.togglingId = item.id
      this.$axios.put(`/approval_templates/${item.id}`, { is_active: newValue })
        .then((response) => {
          Object.assign(item, response.data.data)
          if (newValue) this.$refs.table.$refs.table.refresh()
        })
        .catch((error) => this.failedAlert(error))
        .finally(() => { this.togglingId = null })
    },
    delete(value) {
      return this.$axios.delete(`/approval_templates/${this.getModelKey(value)}`)
    },
    modelPolicy() {
      return {
        _denyShow: !this.$auth.hasPermissionTo('approval_rules.view'),
        _denyEdit: !this.$auth.hasPermissionTo('approval_rules.edit'),
        _denyDelete: !this.$auth.hasPermissionTo('approval_rules.delete'),
      }
    },
    fetchModels(page = 1) {
      return this.$axios.get('/approval_templates', {
        params: {
          // with: 'customer,bank',
          with_count: 'approval_template_steps',
          page: page,
          per_page: this.perPage,
          search: this.search,
          sort: `${this.sortBy === 'name' ? 'id':this.sortBy},${(this.sortDesc || this.sortBy === 'name') ? 'desc' : 'asc'}`,
          ...this.filterParams
        }
      }).then((response) => {
        const { data: { data, meta } } = response;
        this.models = data.map((datum) => ({
          ...datum,
          ...this.modelPolicy(),
        }))
        this.page = Number(meta.current_page);
        this.perPage = Number(meta.per_page);
        this.from = Number(meta.from);
        this.total = Number(meta.total);

        this.stats = [
          {
            title: this.lodash.upperFirst(this.$t('approval_templates.count')),
            value: this.$numeral(this.total).format('0,0 a'),
            valueTitle: this.$numeral(this.total).format('0,0'),
            icon: 'bx bx-user'
          },
        ]

        return response;
      }).catch((error) => this.failedAlert(error));
    }
  },
};
</script>
